<template>
  <div :class="['friendDetail', this.$root.$data.miniprogram ? 'friendDetailApp' : '']">
    <common-title titleName="好友明细" :isAPPShow="true" :bcColor="'#ffffff'"></common-title>
    <div class="detail">
      <div class="detail_item">
        <div class="detail_item_icon">
          <img class="detail_item_icon_img"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend1.png" alt />
        </div>
        <div class="detail_item_info">
          <div class="text">{{ friendDetail.friends }}</div>
          <div class="title">本月新增好友(人)</div>
        </div>
      </div>
      <div class="detail_item">
        <div class="detail_item_icon">
          <img class="detail_item_icon_img"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend2.png" alt />
        </div>
        <div class="detail_item_info">
          <div class="text">{{ friendDetail.courses }}</div>
          <div class="title">本月新增购课(人)</div>
        </div>
      </div>
      <div class="detail_item">
        <div class="detail_item_icon">
          <img class="detail_item_icon_img"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend3.png" alt />
        </div>
        <div class="detail_item_info">
          <div class="text">{{ friendDetail.totalFriends }}</div>
          <div class="title">累计好友(人)</div>
        </div>
      </div>
      <div class="detail_item">
        <div class="detail_item_icon">
          <img class="detail_item_icon_img"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend4.png" alt />
        </div>
        <div class="detail_item_info">
          <div class="text">{{ friendDetail.totalCourses }}</div>
          <div class="title">累计购课(人)</div>
        </div>
      </div>
    </div>
    <div class="list_name">好友明细</div>
    <div class="list_title">
      <div class="list_title1">好友</div>
      <div class="list_title2">加入时间</div>
      <div class="list_title3">报名状态</div>
      <div class="list_title4">绑定状态</div>
    </div>
    <div class="list" v-if="friendList.length">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" :offset="20" v-if="friendList.length"
        @load="onLoad">
        <div class="friendList">
          <div v-for="(item, keys) in friendList" :key="keys">
            <div class="friendList_item">
              <div class="list_title1">{{ rowPhoto(item.friendPhone) }}</div>
              <div class="list_title2">{{ rowData(item.bindDate || '') }}</div>
              <div class="list_title3">
                <img v-if="item.enlists === 1" class="list_title3_img"
                  src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend_yesSign.png"
                  alt />
                <img v-if="item.enlists === 0" class="list_title3_img"
                  src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend_noSign.png"
                  alt />
              </div>
              <div class="list_title4">
                <span>{{ { 1: '绑定中', 2: '已解绑' }[item.status] }}</span>
                <img @click="onWhyToast" v-if="item.status === 2" class="list_title4_img"
                  src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend_why.png"
                  alt />
              </div>
            </div>
          </div>
        </div>
        <div class="friendList_end">已经到底啦</div>
      </van-list>
      <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    </div>
    <div class="list_entry" v-else>
      <img class="list_entry_img"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend_entry.png" alt />
      <div>暂无数据～</div>
    </div>
    <Share :basicInfo="basicInfo" :accountInfo="accountInfo"></Share>
    <van-overlay :show="showTip" @click="showTip = false">
      <div class="wrapper" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span class="wrapper__title_sm">说明</span>
          <img @click="showTip = false"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">好友绑定30天后将自动解除绑定。再次绑定需好友重新扫码</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import {
  reqInvitationInfo,
  reqFriendDetail,
  reqFriendDetailList,
  reqUserAccount,
} from '@/api/invitationCommission';
import { phoneNuberConvert } from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { mapState } from 'vuex';
import { reqUserInfo } from '@/api/index';
import Share from '../components/ShareInvitation/index.vue';

export default {
  components: {
    EmptyData,
    Share,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1000, // 总页数
      friendList: [],
      friendDetail: {},
      refreshing: false,
      loading: false,
      finished: false,
      listEmpty: false,
      basicInfo: {},
      accountInfo: {},
      showTip: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    onWhyToast() {
      this.showTip = true;
    },
    initInfo() {
      console.log('wozhixingle');
      if (!this.userInfo?.id) return;
      console.log('wo到这里zhixingle');
      this.getUserAccount();
      this.getFriendDetail();
      this.getFriendList(1, 20);
    },
    // 查看活动基本信息
    getInvitationInfo() {
      reqInvitationInfo().then(res => {
        this.basicInfo = res;
      });
    },
    // 查看我的账户信息
    getUserAccount() {
      reqUserAccount().then(res => {
        this.accountInfo = res;
        this.$toast.clear();
      });
    },
    rowData(time) {
      return time?.split('-').join('/');
    },
    rowPhoto(number) {
      return phoneNuberConvert(number);
    },
    getFriendDetail() {
      reqFriendDetail().then(res => {
        console.log(res, 'res');
        this.friendDetail = res?.data || {};
      });
    },
    getFriendList(current, size) {
      const subParams = {
        pageNum: current,
        pageSize: size,
      };
      this.loading = true;
      reqFriendDetailList(subParams).then(res => {
        console.log(res, 'res');
        const list = res?.data?.data || [];
        const page = res?.data?.pages || 0;
        this.refreshing = false;
        this.loading = false;
        this.totalPages = page;
        this.friendList = [...this.friendList, ...list];
      });
    },

    onLoad() {
      console.log('触发下拉');
      // this.downLoad = true;
      // this.friendList = [...this.friendList, ...new Array(10).fill({ friendPhone: '18812185899' })];
      // this.loading = false;
      // return;
      if (this.friendList.length >= this.totalPages) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.currentPage += 1;
        this.getFriendList(this.currentPage, 20);
      }
    },
  },
  mounted() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.getInvitationInfo();
    // this.initInfo();
    this.$root.getUserInfo().then(() => {
      console.log('mylogin');
      if (this.userInfo.id) {
        this.initInfo();
      } else if (!(this.$root.$data.isApp || this.$root.$data.miniprogram)) {
        this.$toast.clear();
        const param = { redirect: '/invitation/friendDetail', ...this.$route.query };
        this.$router.push({
          path: '/registrationLogin',
          query: param,
        });
      }
    });
  },
  // watch: {
  //   userInfo: {
  //     deep: true,
  //     immediate: true,
  //     handler(val, old) {
  //       console.log('watch ------===============');
  //     },
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.friendDetail {
  min-height: 100%;
  padding-top: 136px;
  padding-bottom: 167px;
  // overflow: hidden;
  background: rgb(245, 245, 249);

  ::v-deep .van-overlay {
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .detail {
    display: flex;
    flex-wrap: wrap;
    width: 678px;
    height: 286px;
    margin: 0 auto 0;
    background: #fff;
    border-radius: 14px;

    .detail_item {
      width: 339px;
      height: 143px;

      .detail_item_icon {
        float: left;
        width: 80px;
        height: 80px;
        margin-top: 36px;
        margin-left: 36px;

        // border-radius: 14px;
        // overflow: hidden;
        .detail_item_icon_img {
          width: 100%;
          height: 100%;
        }
      }

      .detail_item_info {
        float: left;
        margin-top: 24px;
        margin-left: 22px;

        .text {
          height: 64px;
          color: #333;
          font-weight: 600;
          font-size: 47px;
          font-family: PingFangSC, PingFang SC, sans-serif;
          line-height: 60px;
        }

        .title {
          height: 31px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC, sans-serif;
          line-height: 31px;
        }
      }
    }
  }

  .list_name {
    height: 40px;
    margin-top: 43px;
    margin-left: 36px;
    color: #111;
    font-weight: 500;
    font-size: 29px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 40px;
  }

  .list_title {
    position: sticky;
    top: 10px;
    display: flex;
    width: 678px;
    height: 91px;
    margin: 22px auto 0;
    line-height: 100px;
    background: orange;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invitationCommission/friend5.png') no-repeat;
    background-size: 100% 100%;

    div {
      height: 91px;
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 91px;
    }

    .list_title1 {
      width: 149px;
      margin-left: 30px;
    }

    .list_title2 {
      width: 145px;
      margin-left: 36px;
    }

    .list_title3 {
      width: 104px;
      margin-left: 34px;
    }

    .list_title4 {
      width: 110px;
      margin-left: 47px;
    }
  }

  .list {
    position: relative;
    width: 678px;
    min-height: 757px;
    // height: calc(100% - 518px - 167px - 20px);
    margin: 0 auto;
    // padding-bottom: 43px;
    padding-bottom: 110px;
    // overflow-y: scroll;
    background: white;

    .friendList {
      overflow: hidden;
    }

    .friendList_item {
      display: flex;
      height: 36px;
      margin-top: 43px;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 36px;

      .list_title1 {
        width: 149px;
        margin-left: 29px;
      }

      .list_title2 {
        width: 145px;
        margin-left: 36px;
      }

      .list_title3 {
        width: 104px;
        margin-left: 34px;

        .list_title3_img {
          width: 94px;
          height: 36px;
        }
      }

      .list_title4 {
        width: 110px;
        margin-left: 47px;

        span {
          display: block;
          float: left;
        }

        .list_title4_img {
          display: block;
          float: left;
          width: 22px;
          height: 22px;
          margin-top: 8px;
          margin-left: 4px;
        }
      }
    }

    .friendList_end {
      position: absolute;
      bottom: 36px;
      width: 678px;
      height: 31px;
      color: #999;
      font-weight: 400;
      font-size: 22px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 31px;
      text-align: center;
    }
  }

  .list_entry {
    width: 678px;
    // height: calc(100% - 362px - 167px - 91px - 100px - 22px);
    height: 757px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;

    img {
      display: block;
      width: 308px;
      height: 219px;
      margin: 232px auto 0;
    }

    div {
      width: 100%;
      height: 36px;
      margin: 13px auto 0;
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 36px;
      text-align: center;
    }
  }
}

.friendDetailApp {
  padding-top: 36px;
}

::v-deep .van-overlay {
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  width: 634px;
  height: 259px;
  padding: 31px 33px 0;
  background: #FFF;
  border-radius: 36px;

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    font-style: normal;
    line-height: 40px;
    text-align: center;

    span {
      &:nth-child(1) {
        width: 29px;
        height: 29px;
      }
    }

    & img {
      display: inline-block;
      width: 29px;
      height: 29px;
    }
  }

  &__content {
    height: 43px;
    margin-top: 62px;
    color: #333;
    font-weight: 400;
    font-size: 29px;
    font-style: normal;
    line-height: 43px;
    text-align: left;
  }

  .wrapper__title_sm {
    font-weight: 500;
  }
}
</style>
